const MUIFonts = {
  alertTitle: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '150%',
    fontSize: '16px',
    letterSpacing: '0.15px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  avatarInitials: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '20px',
    fontSize: '20px',
    letterSpacing: '0.14px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  badgeLabel: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '20px',
    fontSize: '12px',
    letterSpacing: '0.14px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  buttonLarge: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '26px',
    fontSize: '15px',
    letterSpacing: '0.46px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textDecoration: 'none',
  },
  buttonMedium: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '24px',
    fontSize: '14px',
    letterSpacing: '0.4px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textDecoration: 'none',
  },
  buttonSmall: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '22px',
    fontSize: '13px',
    letterSpacing: '0.46px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textDecoration: 'none',
  },
  inputLabel: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '12px',
    fontSize: '12px',
    letterSpacing: '0.15px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  helperText: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '166%',
    fontSize: '12px',
    letterSpacing: '0.4px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  inputText: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '24px',
    fontSize: '16px',
    letterSpacing: '0.15px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  chipLabel: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '18px',
    fontSize: '10px',
    letterSpacing: '1.5px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textDecoration: 'none',
  },
  tooltipLabel: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    letterSpacing: '0px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  tableHeader: {
    fontFamily: 'Noto Sans',
    fontWeight: 500,
    lineHeight: '24px',
    fontSize: '14px',
    letterSpacing: '0.17px',
    paragraphSpacing: 0,
    paragraphIndent: 0,
    textCase: 'none',
    textDecoration: 'none',
  },
  menuItem: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '150%',
    fontSize: '16px',
    letterSpacing: '0.15px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  menuItemDense: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '24px',
    fontSize: '14px',
    letterSpacing: '0.17px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  listSubheader: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Medium',
    lineHeight: '48px',
    fontSize: '14px',
    letterSpacing: '0.1px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
  bottomNavigationActiveLabel: {
    fontFamily: 'Noto Sans',
    fontWeight: 'Regular',
    lineHeight: '166%',
    fontSize: '14px',
    letterSpacing: '0.4px',
    paragraphSpacing: '0px',
    paragraphIndent: '0px',
    textCase: 'none',
    textDecoration: 'none',
  },
};
export default MUIFonts;
